/** Variable keys appear in {{CustomerName}} placeholders and text_field.variable_key. */
export const DOC_VARIABLE_KEY_PATTERN = /^[A-Za-z][A-Za-z0-9_]{0,63}$/;

export function isValidDocVariableKey(key: string): boolean {
  return DOC_VARIABLE_KEY_PATTERN.test(key);
}

export function normalizeDocVariableKey(raw: string): string {
  return raw.trim().replace(/\s+/g, "");
}

export function docVariablePlaceholder(key: string): string {
  return `{{${key}}}`;
}
